import { useEffect, useState } from 'react';
import { X, Play } from 'lucide-react';

const VIDEO_URL = 'https://customer-assets.emergentagent.com/job_pay-next-gen/artifacts/29un4t6a_NexGen1ewallet%281%29.MOV';
const ICON_URL = 'https://customer-assets.emergentagent.com/job_pay-next-gen/artifacts/1oy2wqev_ICON.png';

export default function VideoPopup() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('nx_video_shown')) return;
    const timer = setTimeout(() => {
      setShow(true);
    }, 30000);
    return () => clearTimeout(timer);
  }, []);

  const close = () => {
    setShow(false);
    setDismissed(true);
    sessionStorage.setItem('nx_video_shown', 'true');
  };

  const goToDemo = () => {
    close();
    setTimeout(() => {
      document.querySelector('#demo')?.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  return (
    <div
      data-testid="video-popup"
      className="fixed inset-0 z-[99] flex items-center justify-center px-4"
      style={{
        background: 'rgba(0,0,0,0.88)',
        backdropFilter: 'blur(6px)',
        opacity: show ? 1 : 0,
        pointerEvents: show ? 'auto' : 'none',
        transition: 'opacity 0.3s ease',
      }}
    >
      {/* Backdrop click to close */}
      <div className="absolute inset-0" onClick={close} />

      {/* Modal */}
      <div
        className="relative w-full max-w-3xl"
        style={{ zIndex: 100 }}
      >
        {/* Top bar */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-3">
            <img src={ICON_URL} alt="NX" className="h-7 w-7 object-contain" />
            <div>
              <div className="text-[#00FF00] font-mono text-[10px] uppercase tracking-widest">NexGenPay eWallet</div>
              <div className="text-white font-bold text-sm uppercase" style={{ fontFamily: 'Unbounded, sans-serif', fontSize: '11px' }}>
                See It In Action
              </div>
            </div>
          </div>
          <button
            onClick={close}
            data-testid="video-popup-close"
            className="text-[#A3A3A3] hover:text-white transition-colors p-2 border border-[#1A1A1A] hover:border-[#00FF00]"
          >
            <X size={18} />
          </button>
        </div>

        {/* Video container */}
        <div
          className="relative overflow-hidden"
          style={{
            border: '1px solid rgba(0,255,0,0.4)',
            background: '#000',
            boxShadow: '0 0 60px rgba(0,255,0,0.15)',
          }}
        >
          {/* Scan line animation */}
          <div
            className="absolute top-0 left-0 right-0 h-px z-10 pointer-events-none"
            style={{
              background: 'linear-gradient(90deg, transparent, #00FF00, transparent)',
              animation: 'scan-h 3s linear infinite',
              opacity: 0.4,
            }}
          />
          <video
            autoPlay
            controls
            playsInline
            className="w-full block"
            style={{ maxHeight: '60vh', background: '#000' }}
          >
            <source src={VIDEO_URL} type="video/mp4" />
            <source src={VIDEO_URL} type="video/quicktime" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Bottom CTA bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-4 p-4 border border-[#1A1A1A]"
          style={{ background: '#0A0A0A' }}>
          <p className="text-[#A3A3A3] text-sm text-center sm:text-left" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Ready to bring this to your bank?
          </p>
          <div className="flex gap-3 flex-shrink-0">
            <button
              onClick={close}
              className="btn-outline-neon text-xs"
              style={{ fontFamily: 'Unbounded, sans-serif', padding: '10px 20px' }}
            >
              Watch Later
            </button>
            <button
              onClick={goToDemo}
              data-testid="video-popup-demo-btn"
              className="btn-neon text-xs"
              style={{ fontFamily: 'Unbounded, sans-serif', padding: '10px 20px' }}
            >
              Request a Demo
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scan-h {
          0% { top: 0; }
          100% { top: 100%; }
        }
      `}</style>
    </div>
  );
}
